import { memo } from 'react';
import NextHead from 'next/head';

type Props = { schema: object | object[] };

const JsonLd = ({ schema }: Props) => (
  <NextHead>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  </NextHead>
);

export default memo(JsonLd);
